module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_arrow_right_gold-6104137fe374f044df15a2ec76d7b68b.svg";